import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import LocationIcon from '../../icon/LocationIcon';
import GoogleMapReact from 'google-map-react';
import { useDebounce } from 'react-use';
import { Box, CircularProgress, InputAdornment, TextField } from '@mui/material';
import mapApi from './mapApi';
import { LocationValues } from './interface';
import GeoLocationIcon from '../../icon/GeoLocationIcon';
import ChevronDownIcon from '../../icon/ChevronDownIcon';
import EditIcon from '../../icon/EditIcon';

const MarkerIcon =
    'data:image/png;base64,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';

const KEY_CODE = {
    TAB: 9,
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    SEPARATE: 188,
};
export interface LocationPickerProps {
    defaultLocation: {
        lat: number;
        lng: number;
    };
    address: string;
    customAddress: string;
    place?: Partial<LocationValues>;
    onChange: (data: Partial<LocationValues>) => void;
    onChangeAddress: (address: string) => void;
    onChangeCustomAddress: (customAddress: string) => void;
    showTitle?: boolean;
}
export interface LatLng {
    lat: number;
    lng: number;
}
const LocationPicker: React.FC<LocationPickerProps> = ({
    defaultLocation,
    place,
    onChange,
    onChangeAddress,
    address,
    customAddress,
    onChangeCustomAddress,
    showTitle = true,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [maps, setMaps] = useState(null);
    const [map, setMap] = useState(null);
    const [showAddressInput, setShowAddressInput] = useState(false);
    const [placeKeyword, setPlaceKeyword] = useState(address);
    const [hoverIndex, setHoverIndex] = useState(0);
    const [placeList, setPlaceList] = useState([]);
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const autoCompleteService = useMemo(() => {
        if (maps) {
            return new maps.places.AutocompleteService();
        }
    }, [maps]);
    const geoService = useMemo(() => {
        if (maps) {
            return new maps.Geocoder();
        }
    }, [maps]);
    useEffect(() => {
        if (map) {
            map.addListener('dragend', () => {
                const location = map.getCenter();
                onChange({ ...place, latitude: location.lat(), longitude: location.lng() });
            });
        }
    }, [map]);

    const highlightText = (text, matchedSubstring, start, end) => {
        const highlightTextStart = matchedSubstring.offset;
        const highlightTextEnd = highlightTextStart + matchedSubstring.length;

        const beforeText = text.slice(start, highlightTextStart);
        const highlightedText = text.slice(highlightTextStart, highlightTextEnd);
        const afterText = text.slice(highlightTextEnd, end || text.length);
        return [
            beforeText,
            <span key={start} className={`font-bold text-grey-dark`}>
                {highlightedText}
            </span>,
            afterText,
        ];
    };

    const showAddress = (address, matchedSubstrings) => {
        const returnText = [];
        for (let i = 0; i < matchedSubstrings.length; i++) {
            const startOfNext = matchedSubstrings[i + 1]?.offset;
            if (i === 0) {
                returnText.push(highlightText(address, matchedSubstrings[i], 0, startOfNext));
            } else {
                returnText.push(highlightText(address, matchedSubstrings[i], matchedSubstrings[i].offset, startOfNext));
            }
        }
        return returnText.map((text, i) => <Fragment key={i}>{text}</Fragment>);
    };
    useDebounce(
        () => {
            if (autoCompleteService && placeKeyword && placeKeyword.length > 0) {
                setIsLoading(true);
                autoCompleteService.getPlacePredictions(
                    {
                        input: placeKeyword,
                        types: ['address'],
                        location: new maps.LatLng(defaultLocation),
                        radius: 2000,
                    },
                    function (response, status) {
                        if (status === maps.places.PlacesServiceStatus.OK) {
                            setPlaceList(response);
                        } else {
                            setPlaceList([]);
                        }
                        setIsLoading(false);
                    },
                );
            }
        },
        500,
        [autoCompleteService, placeKeyword, defaultLocation, maps],
    );
    const handleOnSelectLocation = (p, placeId, latLng?: LatLng) => {
        if (p.description) {
            setPlaceKeyword(p.description);
            setIsLoadingDetail(true);
            onChangeAddress(p.description);
        }

        const geocodeParams = {};
        if (typeof placeId !== 'undefined' && placeId) {
            geocodeParams['placeId'] = placeId;
        }
        if (typeof latLng !== 'undefined') {
            geocodeParams['location'] = latLng;
        }
        geoService.geocode(geocodeParams, async (response, status) => {
            if (status === maps.GeocoderStatus.OK) {
                const addressComponent = response[0].address_components;
                const formattedAddress = response[0].formatted_address;
                let postcode,
                    country,
                    countryCode,
                    state,
                    city,
                    timezone = '';
                const street = p.description ? p.description : formattedAddress;

                addressComponent.reverse().forEach((component) => {
                    if (component.types.includes('postal_code')) {
                        postcode = component.long_name;
                    }
                    if (component.types.includes('country')) {
                        country = component.long_name;
                        countryCode = component.short_name;
                    }

                    const havingState = [
                        'Australia',
                        'Brazil',
                        'Ethiopia',
                        'Germany',
                        'India',
                        'Mexico',
                        'Micronesia',
                        'Myanmar',
                        'Nigeria',
                        'Palau',
                        'South Sudan',
                        'United States',
                    ].includes(country);

                    if (component.types.includes('administrative_area_level_1')) {
                        if (havingState) {
                            state = component.long_name;
                        } else {
                            city = component.long_name;
                            state = '';
                        }
                    }
                    if (component.types.includes('administrative_area_level_2') && havingState) {
                        city = component.short_name;
                    }
                });
                try {
                    const timezoneResponse = await mapApi.getTimezone(
                        response[0].geometry.location.lat() + ',' + response[0].geometry.location.lng(),
                    );
                    if (timezoneResponse.data.status === 'OK') {
                        timezone = timezoneResponse.data.timeZoneId;
                    } else {
                        timezone = '';
                    }
                } catch (e) {}
                map.setCenter(response[0].geometry.location);
                if (response[0].geometry.viewport) {
                    map.fitBounds(response[0].geometry.viewport);
                }
                onChange({
                    postcode,
                    country,
                    countryCode,
                    state,
                    city,
                    street,
                    timezone,
                    latitude: map.getCenter().lat(),
                    longitude: map.getCenter().lng(),
                });
                if (!p.description && formattedAddress) {
                    setPlaceKeyword(formattedAddress);
                    setIsLoadingDetail(true);
                    onChangeAddress(formattedAddress);
                }
            }
            setIsLoadingDetail(false);
        });
    };
    const onKeydown = (e) => {
        if ([KEY_CODE.ENTER, KEY_CODE.UP, KEY_CODE.DOWN].includes(e.keyCode)) {
            if (placeList.length > 0) {
                // eslint-disable-next-line default-case
                switch (e.keyCode) {
                    case KEY_CODE.UP:
                    case KEY_CODE.DOWN:
                        let offset = 0;
                        if (e.keyCode === KEY_CODE.UP) {
                            offset = -1;
                        } else if (e.keyCode === KEY_CODE.DOWN) {
                            offset = 1;
                        }
                        if (offset !== 0) {
                            const maxIdx = placeList.length - 1;
                            setHoverIndex(Math.max(0, Math.min(hoverIndex + offset, maxIdx)));
                        }
                        break;
                    case KEY_CODE.ENTER:
                        if (hoverIndex !== -1) {
                            handleOnSelectLocation(placeList[hoverIndex], placeList[hoverIndex].place_id);
                            inputRef.current.blur();
                        }
                        break;
                }
            }
            e.preventDefault();
        }
    };
    useEffect(() => {
        if (customAddress) {
            setShowAddressInput(true);
        }
    }, [customAddress]);

    const showCustomLabel = useMemo(() => {
        if (placeKeyword) return true;
        return false;
    }, [placeKeyword]);

    const handleGeoLocationClick = () => {
        if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                handleOnSelectLocation(
                    {
                        description: null,
                    },
                    null,
                    { lat: position.coords.latitude, lng: position.coords.longitude },
                );
            });
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    };

    return (
        <Fragment>
            <div className={`relative z-1`}>
                <div className="flex items-center mb-16">
                    <div
                        className={`flex-auto h-40 border border-primary-40 text-primary-80 rounded-6 flex items-center hover:border-info-60 focus-within:border-info focus-within:text-info`}
                    >
                        <div className="text-18 ml-12 mr-8">
                            <LocationIcon />
                        </div>
                        <input
                            ref={inputRef}
                            autoComplete="off"
                            name={'place'}
                            className={`w-full mr-18 text-14 font-normal text-grey-dark`}
                            placeholder="Search for your busin&#8204;ess addr&#8204;ess"
                            value={placeKeyword}
                            onChange={(e) => {
                                setIsLoading(true);
                                setPlaceKeyword(e.target.value);
                            }}
                            onFocus={() => setShowSuggestion(true)}
                            onBlur={() => {
                                setShowSuggestion(false);
                                setHoverIndex(0);
                            }}
                            onKeyDown={onKeydown}
                        />
                    </div>
                    <div className={'px-10 cursor-pointer'} onClick={handleGeoLocationClick}>
                        <GeoLocationIcon />
                    </div>
                </div>
                {showSuggestion && placeKeyword && placeKeyword.length > 0 && (
                    <div className={`absolute left-0 right-0 top-40 bg-white p-16 select-none shadow mt-2`}>
                        {isLoading ? (
                            <div className={`px-10 py-4`}>
                                <CircularProgress size={18} thickness={5} color={`primary`} />
                            </div>
                        ) : (
                            <Fragment>
                                {placeList.map((place, index) => (
                                    <div
                                        key={place.place_id}
                                        className={`py-12 px-10 cursor-pointer hover:bg-gradient-light text-grey-mid rounded-6 ${
                                            hoverIndex === index ? 'bg-grey-hover' : ''
                                        }`}
                                        onMouseDown={() => handleOnSelectLocation(place, place.place_id)}
                                    >
                                        {showAddress(place.description, place.matched_substrings)}
                                    </div>
                                ))}
                                {placeList.length === 0 && <div className={``}>Not Found</div>}
                            </Fragment>
                        )}
                    </div>
                )}
            </div>
            <Box
                sx={{
                    height: 200,
                }}
                className={`relative  overflow-hidden rounded-6 border border-primary-10`}
            >
                <div className={`absolute top-0 left-0 w-full h-full`}>
                    {defaultLocation && (
                        <GoogleMapReact
                            bootstrapURLKeys={{
                                key: process.env.REACT_APP_GOOGLE_KEY,
                                libraries: ['places'],
                            }}
                            defaultCenter={defaultLocation}
                            defaultZoom={12}
                            options={{
                                fullscreenControl: false,
                                gestureHandling: 'cooperative',
                            }}
                            onGoogleApiLoaded={({ map, maps }) => {
                                setMap(map);
                                setMaps(maps);
                            }}
                        ></GoogleMapReact>
                    )}
                </div>
                <div className={`absolute top-1/2 left-1/2 transform -translate-y-full -translate-x-1/2`}>
                    <img src={MarkerIcon} width={20} alt="location" />
                </div>
            </Box>

            <div className={`mt-10 ${!showCustomLabel && 'hidden'}`}>
                <div
                    className={'mb-10 text-10 font-bold text-success underline cursor-pointer'}
                    onClick={() => setShowAddressInput(true)}
                >
                    <ChevronDownIcon /> Use custom label?
                </div>
                <div className={`${!showAddressInput && 'hidden'}`}>
                    <TextField
                        name="customAddress"
                        placeholder=""
                        fullWidth
                        onChange={(e) => {
                            onChangeCustomAddress(e.target.value);
                        }}
                        value={customAddress}
                        inputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EditIcon />
                                </InputAdornment>
                            ),
                            maxLength: 200,
                        }}
                    />
                    <div className={'mt-10 text-10 text-primary-70'}>Maximum 200 characters</div>
                </div>
            </div>
        </Fragment>
    );
};

export default LocationPicker;
